import { createSlice } from "@reduxjs/toolkit";
import { AuditLogResponseDto } from "../../shared/dtos/auditLog/AuditLogResponseDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

const auditLogSlice = createSlice({
  name: "auditLog",
  initialState: getInitialListState<AuditLogResponseDto>(),
  reducers: { ...generateListReducers<AuditLogResponseDto>() },
});

export const auditLogActions = auditLogSlice.actions;
export default auditLogSlice.reducer;
